<template>
  <div>
    <address-autocomplete
      v-model="formData.street"
      :address-selected="onAddressSelected"
      :validate="'required'"
      :label="withLabels ? 'Address' : ''"
      with-address-form
      :name="`${fieldsNamePrefix}street`"
      :placeholder="addressPlaceholder"
    />

    <text-field
      v-model="formData.apartment"
      :name="`${fieldsNamePrefix}apartment`"
      :placeholder="withLabels ? 'Optional' : 'Unit Number, Loading Dock #, etc'"
      column="2"
      :label="withLabels ? 'Unit Number, Loading Dock #, etc' : ''"
    />
    <text-field
      v-model="formData.city"
      :validate="'required'"
      :name="`${fieldsNamePrefix}city`"
      placeholder="City"
      :label="withLabels ? 'City' : ''"
    />
    <template v-if="stateDropdown">
      <dropdown
        optionalyAvailable
        v-if="hasStateData"
        :selected-name="selectedStateName"
        :placeholder="'State'"
        class="pt-30"
        :dropdown-items="stateList"
        style="width: calc(50% - 15px);float:right; clear: none; margin-top:-3px"
      />
    </template>
    <text-field
      v-else
      v-model="formData.state"
      :validate="'required'"
      :name="`${fieldsNamePrefix}state`"
      column="2"
      placeholder="State"
      :label="withLabels ? 'State' : ''"
    />
    <text-field
      v-model="formData.zip_code"
      :validate="'required'"
      :name="`${fieldsNamePrefix}zip_code`"
      placeholder="Zip Code"
      :label="withLabels ? 'Zip Code' : ''"
    />
    <text-field
      v-model="formData.country"
      :validate="'required'"
      :name="`${fieldsNamePrefix}country`"
      column="2"
      placeholder="Country/Region"
      :label="withLabels ? 'Country/Region' : ''"
    />
  </div>
</template>

<script>
import MiscApi from "@/services/api/misc";

const MiscApiService = new MiscApi();

export default {
  inject: ["parentValidator"],
  props: {
    addressChanged: {
      type: Function,
      default: () => {
      }
    },
    withLabels: {
      type: Boolean,
      default: false
    },
    stateDropdown: {
      type: Boolean,
      default: false
    },
    addressPlaceholder: {
      type: String,
      default: "Address"
    },
    initialData: {
      type: Object
    },
    fieldsNamePrefix: {
      type: String,
      default: ""
    }
  },
  data: function() {
    const { street, zip_code, city, state, country, apartment } = this.initialData || {};
    return {
      formData: {
        street: street || "",
        zip_code: zip_code || "",
        city: city || "",
        state: state || "",
        country: country || "",
        apartment: apartment || ""
      },
      stateData: [],
      stateList: []

    };
  },
  watch: {
    formData: {
      handler() {
        this.addressChanged(this.formData);
        this.setStateList(this.formData.country === "Canada" ? "CA" : "US");
      },
      deep: true
    }
  },
  async created() {
    this.$validator = this.parentValidator;
    if (this.stateDropdown) {
      this.getLocations();
    }
  },
  computed: {
    selectedStateName: function() {
      const selectedStateName = this.stateData[0].states.concat(this.stateData[1].states)
        .filter(state => this.formData.state === state.code)
        .map(state => state.name);
      return selectedStateName[0];
    },
    hasStateData: function() {
      return this.stateData.length !== 0;
    }
  },
  methods: {
    onAddressSelected: async function(addressObject) {
      this.formData = addressObject;
    },
    getLocations: async function() {
      this.stateData = await MiscApiService.getLocations();
      if (this.formData) {
        this.setStateList(this.formData.country === "Canada" ? "CA" : "US");
      } else {
        this.setStateList("US");
      }
    },
    setStateList: function(country) {
      this.stateList = this.stateData[(country === "US") ? 0 : 1].states
        .map(state => ({
          value: state.code,
          name: state.name
        }));
    }
  }
};
</script>
